import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function fetchExaminer() {
  return axiosInstance.get(`${BASE_URL}/api/examiners`);
}

export function fetchOneExaminer(examinerId) {
  return axiosInstance.get(`${BASE_URL}/api/examiners/${examinerId}`);
}

export function createExaminer(body) {
  return axiosInstance.post(`${BASE_URL}/api/examiners`, body);
}

export function patchExaminer(examinerId, body) {
  return axiosInstance.patch(`${BASE_URL}/api/examiners/${examinerId}`, body);
}

export function deleteExaminer(examinerId) {
  return axiosInstance.delete(`${BASE_URL}/api/examiners/${examinerId}`);
}
